/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderDetailResultSingleResult } from '../models/OrderDetailResultSingleResult';
import type { OrderItemParams } from '../models/OrderItemParams';
import type { OrderRequestParams } from '../models/OrderRequestParams';
import type { TakeoutCountersResultSingleResult } from '../models/TakeoutCountersResultSingleResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaFoodPickupService {
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaFoodPickupIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/foodPickup/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * Creates a new food order.
     * @returns OrderDetailResultSingleResult New order was successfully created.
     * @throws ApiError
     */
    public static postOrder({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * Order model.
         */
        requestBody?: OrderRequestParams,
    }): CancelablePromise<OrderDetailResultSingleResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/foodPickup/orders/new',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns a list of all takeout counters available in a locality, for a specific production and from a given time.
     * Authorization: FAUSER or PUBLIC_WEB_USER.
     * @returns TakeoutCountersResultSingleResult Takeout counters and places were successfully found.
     * @throws ApiError
     */
    public static getTakeoutCounters({
        apiVersion = 1,
        localityId,
        productTypeId,
        dateFrom,
    }: {
        apiVersion?: number,
        /**
         * Globus hypermarket number
         */
        localityId?: number,
        /**
         * Production type ID, if omitted, 1 is used
         */
        productTypeId?: number,
        /**
         * Date from which takeout counters should be available, if omitted, current date is used
         */
        dateFrom?: string,
    }): CancelablePromise<TakeoutCountersResultSingleResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/foodPickup/orders/takeoutCounters/production',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'localityId': localityId,
                'productTypeId': productTypeId,
                'dateFrom': dateFrom,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns a list of all takeout counters available in a locality, for a specific production and from a given time - filtered
     * @returns TakeoutCountersResultSingleResult Takeout counters and places were successfully found.
     * @throws ApiError
     */
    public static getTakeoutCountersFiltered({
        dateFrom,
        apiVersion = 1,
        localityId,
        productTypeId,
        requestBody,
    }: {
        /**
         * Date from which takeout counters should be available
         */
        dateFrom: string,
        apiVersion?: number,
        /**
         * Globus hypermarket number
         */
        localityId?: number,
        /**
         * Production type ID, if omitted, 1 is used
         */
        productTypeId?: number,
        /**
         * Order model.
         */
        requestBody?: {
            /**
             * List of items in the order.
             */
            orderItems?: Array<OrderItemParams> | null;
        },
    }): CancelablePromise<TakeoutCountersResultSingleResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/foodPickup/orders/takeoutCounters/productionFiltered',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'localityId': localityId,
                'productTypeId': productTypeId,
                'dateFrom': dateFrom,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
